export default "__VITE_ASSET__DMTTHEG0__"